import { defined } from "@cesium/engine";
import subscribeAndEvaluate from "../../subscribeAndEvaluate";

class DitapAnimation {
  constructor(parent, viewModel, animationOpenTag) {
    this._animationOpenTag = animationOpenTag;
    this._viewModel = viewModel;

    const animationElement = this.createAnimationElement();
    this._animationContainer = animationElement.animationContainer;
    this._speed = animationElement.speed;
    this._time = animationElement.time;
    this._date = animationElement.date;
    this._closeButton = animationElement.closeButton;
    this._rewindButton = animationElement.rewindButton;
    this._pauseButton = animationElement.pauseButton;
    this._playButton = animationElement.playButton;
    this._sliderInput = animationElement.sliderInput;
    this._resetButton = animationElement.resetButton;
    this._suggleRingTicks = this.getShuttleRingTicks();

    parent.appendChild(this._animationContainer);

    this.slider(this._sliderInput);
    this.createEvent();
  }

  get animationContainer() {
    return this._animationContainer;
  }

  getShuttleRingTicks() {
    const originalArray = this._viewModel.getShuttleRingTicks();
    // 배열을 오름차순으로 정렬
    originalArray.sort((a, b) => a - b);

    // 음수 배열 생성 및 추가
    const negativeArray = originalArray.map((num) => -num);

    // 음수 배열과 원래 배열을 병합하고 다시 정렬
    const resultArray = negativeArray
      .concat(originalArray)
      .sort((a, b) => a - b);

    return resultArray;
  }

  createEvent() {
    this._closeButton.addEventListener(
      "click",
      (this._closeEvent = () => {
        this.close();
      })
    );

    this._playButton.addEventListener(
      "click",
      (this._playEvent = () => {
        const command = this._viewModel.playForwardViewModel.command;
        if (command.canExecute) {
          command();
        }
        this.slider(this._sliderInput);
      })
    );

    this._pauseButton.addEventListener(
      "click",
      (this._playEvent = () => {
        const command = this._viewModel.pauseViewModel.command;
        if (command.canExecute) {
          command();
        }
      })
    );

    this._rewindButton.addEventListener(
      "click",
      (this._playEvent = () => {
        const command = this._viewModel.playReverseViewModel.command;
        if (command.canExecute) {
          command();
        }
        this.slider(this._sliderInput);
      })
    );

    this._resetButton.addEventListener(
      "click",
      (this._playEvent = () => {
        const command = this._viewModel.playRealtimeViewModel.command;
        if (command.canExecute) {
          command();
        }
      })
    );

    this._sliderInput.addEventListener("input", () => {
      const value = Number(this._sliderInput.value);
      const resultArray = this._suggleRingTicks;

      this._viewModel.clockViewModel.clock.multiplier = resultArray[value];
      this.slider(this._sliderInput);
    });

    subscribeAndEvaluate(this._viewModel, "dateLabel", (value) => {
      if (this._date.textContent !== value) {
        this._date.textContent = value;
      }
    });

    subscribeAndEvaluate(this._viewModel, "timeLabel", (value) => {
      if (this._time.textContent !== value) {
        this._time.textContent = value;
      }
    });

    subscribeAndEvaluate(this._viewModel, "multiplierLabel", (value) => {
      if (this._speed.textContent !== value) {
        this._speed.textContent = value;
        if (defined(this._suggleRingTicks)) {
          const index = this.findIndex(
            this._suggleRingTicks,
            parseFloat(value)
          );
          this._sliderInput.value = index;
          this.slider(this._sliderInput);
        }
      }

      if (value === "Today") {
        this._sliderInput.value = 30;
        this.slider(this._sliderInput);
      }
    });
  }

  findIndex(arr, num) {
    let start = 0;
    let end = arr.length - 1;

    while (start <= end) {
      const mid = Math.floor((start + end) / 2);

      if (arr[mid] === num) {
        return mid;
      } else if (arr[mid] < num) {
        start = mid + 1;
      } else {
        end = mid - 1;
      }
    }

    return end;
  }

  slider(input) {
    const min = Number(input.min);
    const max = Number(input.max);
    const value = Number(input.value);
    const percentage = ((value - min) / (max - min)) * 100;
    input.style.backgroundImage =
      "linear-gradient(to right, #EEC252 0%, #EEC252 " +
      `${percentage}` +
      "%, #AAA " +
      `${percentage}` +
      "%, #AAA 100%)";
  }

  getTime() {
    return `${this._viewModel.dateLabel} ${this._viewModel.timeLabel}`;
  }

  close() {
    this._animationContainer.classList.add("hide");
    this._animationOpenTag.classList.remove("hide");
  }

  open() {
    this._animationContainer.classList.remove("hide");
  }

  createAnimationElement() {
    // 새로운 div 요소 생성
    const animationContainer = document.createElement("div");
    animationContainer.classList.add("ditap-animation-container");
    animationContainer.classList.add("hide");

    // 상위 요소 생성
    const topWrap = document.createElement("div");
    topWrap.classList.add("ditap-animation-top-wrap");

    const speed = document.createElement("p");
    speed.classList.add("ditap-animation-speed");
    speed.textContent = this._viewModel.multiplierLabel;

    const dateTime = document.createElement("p");
    dateTime.classList.add("ditap-animation-time");
    const time = document.createElement("p");
    time.style.marginLeft = "3px";
    const date = document.createElement("p");
    dateTime.appendChild(date);
    dateTime.appendChild(time);

    const closeButton = document.createElement("button");
    closeButton.classList.add("ditap-popup-close-btn");
    closeButton.classList.add("ditap-custom-button");

    topWrap.appendChild(speed);
    topWrap.appendChild(dateTime);
    topWrap.appendChild(closeButton);

    // 하위 요소 생성
    const botWrap = document.createElement("div");
    botWrap.classList.add("ditap-animation-bot-wrap");

    const rewindButton = document.createElement("button");
    rewindButton.classList.add("ditap-animation-btn", "ditap-custom-button");
    rewindButton.classList.add("rewind-btn");

    const pauseButton = document.createElement("button");
    pauseButton.classList.add("ditap-animation-btn", "ditap-custom-button");
    pauseButton.classList.add("pause-btn");

    const playButton = document.createElement("button");
    playButton.classList.add("ditap-animation-btn", "ditap-custom-button");
    playButton.classList.add("play-btn");

    const sliderWrapper = document.createElement("div");
    sliderWrapper.classList.add("diatp-animation-slider-wrap");

    const label = document.createElement("label");

    const sliderInput = document.createElement("input");
    sliderInput.setAttribute("id", "slider0");
    sliderInput.setAttribute("type", "range");
    sliderInput.setAttribute("step", 1);
    sliderInput.setAttribute("value", "30");
    sliderInput.setAttribute("min", "0");
    sliderInput.setAttribute("max", "59");
    sliderInput.setAttribute("name", "slider");
    sliderInput.classList.add("ditap-slider", "ditap-custom-button");

    label.appendChild(sliderInput);
    sliderWrapper.appendChild(label);

    const resetButton = document.createElement("button");
    resetButton.classList.add("ditap-animation-btn");
    resetButton.classList.add("reset-btn", "ditap-custom-button");

    botWrap.appendChild(rewindButton);
    botWrap.appendChild(pauseButton);
    botWrap.appendChild(playButton);
    botWrap.appendChild(sliderWrapper);
    botWrap.appendChild(resetButton);

    // 상위 요소와 하위 요소를 연결하여 최종 요소 생성
    animationContainer.appendChild(topWrap);
    animationContainer.appendChild(botWrap);

    // 최종 요소를 문서에 추가
    return {
      animationContainer: animationContainer,
      speed: speed,
      time: time,
      date: date,
      closeButton: closeButton,
      rewindButton: rewindButton,
      pauseButton: pauseButton,
      playButton: playButton,
      sliderInput: sliderInput,
      resetButton: resetButton,
    };

    /* 
            <div class="ditap-animation-container">
                <div class="ditap-animation-top-wrap">
                <p class="ditap-animation-title">Today</p>
                <p class="ditap-animation-time">2024년 4월 3일 오전 00:00</p>
                <button class="ditap-popup-close-btn"></button>
                </div>
                <div class="ditap-animation-bot-wrap">
                <button class="ditap-animation-rewind-btn"></button>
                <button class="ditap-animation-pause-btn"></button>
                <button class="ditap-animation-play-btn"></button>
                <div class="diatp-animation-slider-wrap">
                    <label>
                    <input id="slider0" oninput="slider(this)" class="ditap-slider" type="range" min="0" max="100" name="slider" />
                    </label>
                </div>
                <button class="ditap-animation-reset-btn"></button>
                </div>
            </div>
        */
  }

  /**
   * 위젯 파괴.
   * Destroys the widget.
   */
  destroy() {
    if (this._closeEvent) {
      window.removeEventListener("click", this._closeEvent);
    }
    if (this._playButton) {
      window.removeEventListener("click", this._playButton);
    }
    if (this._pauseButton) {
      window.removeEventListener("click", this._pauseButton);
    }
    if (this._rewindButton) {
      window.removeEventListener("click", this._rewindButton);
    }
    if (this._resetButton) {
      window.removeEventListener("click", this._resetButton);
    }
    if (this._sliderInput) {
      window.removeEventListener("input", this._sliderInput);
    }
  }
}

export default DitapAnimation;
